import AdminDashboardModule from './containers/adminDashboardModule'

export {default as AdminDashboardModuleLayout} from './components/adminDashboardModuleLayout'

export default AdminDashboardModule
